var exports = {
  "tabs": "x28a7bf27--a7007e--tabs",
  "tab": "x28a7bf27--a7007e--tab",
  "inner": "x28a7bf27--a7007e--inner",
  "active": "x28a7bf27--a7007e--active",
  "house": "x28a7bf27--a7007e--house",
  "cottage": "x28a7bf27--a7007e--cottage",
  "land": "x28a7bf27--a7007e--land",
  "townhouse": "x28a7bf27--a7007e--townhouse",
  "build": "x28a7bf27--a7007e--build",
};

module.exports = exports;
